import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { APIRequest } from '../../../application/helper/APIRequest';
import useRouter from '../../../application/useRouter';
import { colors, font, screen } from '../../../styles/variables';
import Layout from '../../components/layout';
import Loading from '../../components/loading';
import { Divider, PageWrapper, WrapperTitle } from '../../components/template';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

const WraaperTable = styled.div`
  margin: 30px 0;

  @media(max-width: ${screen.xs.max}){
    overflow: scroll;
  }
`;

const Table = styled.table`
  width: 100%;
  /* font-family: 'Open Sans'; */
  font-weight: 600;
`;

const Thead = styled.thead`
  text-align: left;
  color: ${font.color.thead};
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
`;

const Tbody = styled.tbody`
  tr {
      &:hover {
      background: #dfdfdf;
    }
  }
`;

const TR = styled.tr`

  &:nth-child(even){
    background: #f3f1f1;
  }
`;

const TH = styled.th`
  font-weight: lighter;
  padding: 10px 20px;
  font-size: 14px;

  background-color: ${colors.thead};
  color: ${font.color.thead};

  ${props => props.center && css`
    text-align: center;
  `}  
`;

const TD = styled.td`
  font-weight: lighter;
  padding: 10px 20px;
  font-size: ${font.size.small};
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  color: ${font.color.default};
  .icon {
    cursor: pointer;
    font-size: 18px;
  }
  
  ${props => props.light && css`
    color: ${font.color.light};
  `}

  ${props => props.fixWidth && css`
    max-width: 140px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}

  ${props => props.center && css`
    text-align: center;
  `}  
  
  ${props => props.trans && css`
    label {
      text-decoration: underline;
      color: ${colors.primary.default};
      cursor: pointer;
    }
  `}

  ${props => props.pagination && css`
    border: none;

    &:hover {
      background: ${colors.panel};
    }
  `}  
  
  ${props => props.nodata && css`
    &:hover {
      background: ${colors.panel};
    }
  `}

  ${props => props.status === true && css`
    color: #267427;
    font-weight: bold;
  `}

  ${props => props.status === false && css`
    color: #d12222;
    font-weight: bold;
  `}
`;

const NoData = styled.p`
  text-align: center;
  font-size: 24px;
  font-weight: lighter;
  color: #dfdfdf;
  font-style: italic;
`;

const IconAction = styled.div`
  cursor: pointer;
  color: ${colors.primary.default};
`;

function ListPage(){
  const router = useRouter();
  const [lists, setLists] = useState();
  
  function getDataLists(){
    APIRequest({
      method: 'GET',
      url: '/external/form-wallet/list',
    }).then(response => {
      if(response && response.code === 0) {
        setLists(response.result);
      }
    })
  }

  function handleAction(id){
    if(id) router.push(`/detail/${id}`);
  }
  
  useEffect(() => {
    getDataLists();
  }, []);

  return (
    <Layout>
      { !lists && <Loading /> }
      <PageWrapper>
      <WrapperTitle>
        <h3>รายชื่อผู้ส่งแบบฟอร์ม</h3>
      </WrapperTitle>
      <Divider color="true" />

        <WraaperTable>
            <Table>
              <Thead>
                <TR>
                  <TH>Request NO.</TH>
                  <TH>Prefix</TH>
                  <TH>Name</TH>
                  <TH>Date</TH>
                  <TH></TH>
                </TR>
              </Thead>
              { lists?.length > 0
                ?
                  <>
                    <Tbody>
                      { lists.map((item, index) => (
                        <TR key={index}>
                          <TD>{item.requestNo || '-'}</TD>
                          <TD>{item.prefix || '-'}</TD>
                          <TD>{item.name || '-'}</TD>
                          <TD>{moment(item.updateDate).locale('th').format('DD/MM/YYYY') || '-'}</TD>
                          <TD>
                            <IconAction 
                              onClick={ () => handleAction(item['_id']) }
                            >
                              <FontAwesomeIcon className="icon" icon={faEye} />
                            </IconAction>
                          </TD>
                        </TR>
                      ))}
                    </Tbody>
                  </>
                :
                  <Tbody>
                    <TR>
                      <TD nodata colSpan={9}>
                        <NoData>
                          No data available in table.
                        </NoData>
                      </TD>
                    </TR>
                  </Tbody>
              }
            </Table>
          </WraaperTable>
      </PageWrapper>
    </Layout>
  )
}

export default ListPage;